import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import cn from 'classnames';
import { MenuItem, Select, Label, Button } from 'mw-style-react';
import { withPrefix } from 'gatsby-link';
import { Link as GatsbyLink } from 'gatsby';
import './Footer.scss';
import { Link } from '../../i18n';
import UtilsApi from '../../utils/api';
import Image from '../Image/Image';
import {
  iconArrow,
  iconGithub
} from '../../images';
const host = process.env.GATSBY_HOST;
const AWS_MARKETPLACE_URL = 'https://aws.amazon.com/marketplace/pp/prodview-dbnuv3b3g5jf2';
const ISO_CERTIFICATION_PATH = '/blog/corezoid-iso-27001-2022-recertification/';
const RECYCLING_SOFTWARE_PATH = '/recycling-software/';
const CLAUDE_PARTNER_CERTIFICATION_PATH = '/blog/corezoid-certified-claude-partner-network/';

let location = '';
if (typeof window !== 'undefined') {
  location = window.location.origin;
}

// import apple from '../../../images/platforms/apple-logo-grey.webp';
// import android from '../../../images/platforms/android-logo-grey.webp';
// import windows from '../../../images/platforms/windows-logo-grey.webp';
// import linux from '../../../images/platforms/linux-logo-grey.webp';

class Footer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      lang: props.intl.locale,
      email: '',
      sendSubscribe: false,
      error: true,
      trySend: false
    };
  }

  validateEmail(value) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(value));
  }

  handleChangeEmail(value) {
    this.setState({
      email: value,
      error: !this.validateEmail(value),
      trySend: false
    });
  }

  handleSubscribe() {
    if (this.state.error) {
      this.setState({
        trySend: true
      });
      return;
    }

    const body = {
      form_id: 'subscribeForm',
      action: 'subscribe',
      fields: [{
        key: 'email',
        value: this.state.email
      }]
    };
    const url = `${host}/api/1/json/public/513644/6d85995d468d2cd7d26930393473dff049842412`;
    UtilsApi.sendForm(body, url);
    this.setState({
      email: '',
      sendSubscribe: true,
    });
  }

  renderInput(intl, item) {
    if (this.state.sendSubscribe) {
      return (
        <div className="footer__column__item__input__done" key={'input'}>
          <Label value={intl.formatMessage({id: item.textDane})} />
        </div>
      );
    }
    return (
      <div key={`key_${item.text}`}>
        <div className="footer__column__item__input__wrap">
          <input
            className="footer__column__item__input is-centered"
            placeholder={this.props.intl.formatMessage({id: item.text})}
            value={this.state.email}
            length={40}
            type={'email'}
            onChange={(data) => this.handleChangeEmail(data.target.value)}
            aria-label={this.props.intl.formatMessage({id: item.text})}
            id="footer-email-input"
            name="email"
            required
          />
          <Button
            className={'button__default footer__column__item__input__btn'}
            label={intl.formatMessage({id: item.buttonText})}
            onClick={() => this.handleSubscribe()}
            id={'news_subscribe'}
            aria-label={intl.formatMessage({id: item.buttonText})}
          />
        </div>
        {this.state.trySend && this.state.error &&
          <Label className="footer__column__item__input__error" value={'invalid email'} />
        }
      </div>
    );
  }

  renderSocial(intl, item) {
    return (
      <div className="footer__column__item__social" key={'links'}>
        {item.links.map(link => (
          <Link to={link.link} key={`id_${link.link}`}>
            <Image
              className="footer__column__item__social__image"
              file={link.image}
            />
          </Link>
        ))}
      </div>
    );
  }

  renderLang(intl) {
    const { lang } = this.state;
    return (
      <Fragment key={lang}>
        {lang !== 'en' ? (
          <div>
            <Select
              id={lang}
              className="footer__lang"
              // label={intl.formatMessage({id: `lang${lang}`})}
              value={lang}
              onChange={(data) => this.handleChange(data)}
            >
              <MenuItem
                label={`🇺🇸  ${intl.formatMessage({id: 'langen'})}`}
                value={'en'}
              />
              <MenuItem
                label={`🇷🇺  ${intl.formatMessage({id: 'langru'})}`}
                value={'ru'}
              />
            </Select>
          </div>
      ) : null}
      </Fragment>
    );
  }

  renderColumn(list, intl) {
    return list.map((column, index) => (
      <div
        key={index}
        className="footer__column"
      >
        <h3 className="footer__column__title">
          {intl.formatMessage({id: column.title})}
        </h3>
        <div className="footer__column__list">
          {column.list.map((item, index) => {
            const isFavorite = item.favorite;
            if (item.type === 'image') {
              return <img key={index} className="footer__column__item__img" src={item.src} alt="AWS"/>;
            }

            if (item.type === 'text') {
              return (
                <div className="footer__column__item__text" key={index}>
                  <Label value={intl.formatMessage({id: item.text})} />
                </div>
              );
            }

            if (item.type === 'input') {
              return this.renderInput(intl, item);
            }

            if (item.type === 'social') {
              return this.renderSocial(intl, item);
            }

            if (item.type === 'lang') {
              return this.renderLang(intl);
            }


            if (item.link.indexOf('http') !== -1) {
              return (
                <Link
                  key={index}
                  to={item.link}
                  className={cn('footer__column__item', { highlight: isFavorite})}
                >
                  {item.icons &&
                    item.icons.map((icon, index) => (
                      <img
                        className={'footer__column__item__icon'}
                        key={index}
                        src={icon}
                        alt=""
                      />
                    ))
                  }
                  <p>
                    {intl.formatMessage({id: item.name})}
                  </p>
                  {isFavorite && (
                    <img src={iconArrow} alt="More"/>
                  )}
                </Link>
              );
            }

            return (
              <Link
                key={index}
                to={item.link}
                className={cn('footer__column__item', { highlight: isFavorite})}
              >
                {item.icons &&
                  item.icons.map((icon, index) => (
                    <img
                      className={'footer__column__item__icon'}
                      key={index}
                      src={icon}
                      alt=""
                    />
                  ))
                }
                <p>
                  {intl.formatMessage({id: item.name})}
                </p>
                {isFavorite && (
                  <img src={iconArrow} alt="More"/>
                )}
              </Link>
            );
          })}
        </div>
      </div>
    ));
  }

  handleChange(data) {
    let language = data.value;
    if (language !== this.state.lang) {
      if (typeof window !== 'undefined') {
        let pathname = window.location.pathname;
        if (this.state.lang !== 'en') {
          pathname = window.location.pathname.replace(this.state.lang, '');
        }
        window.localStorage.setItem('language', language);
        if (language === 'en') {
          language = '';
        }
        const newUrl = withPrefix(`/${language}${pathname}`);
        window.location.replace(newUrl);
      }
    }
  }

  render() {
    const { intl } = this.props;
    const { lang } = this.state;
    const year = new Date().getFullYear();

    const footer = [
      {
        title: 'footerLinkResources',
        list: [
          {
            name: 'footerLinkQuickStart',
            link: lang === 'en' ? 'https://doc.corezoid.com/docs/quick-start-1' : 'https://doc.corezoid.com/docs/quick-start-1',
            favorite: false
          },
          { name: 'footerLinkTutorials', link: '/tutorials', favorite: false },
          {
            name: 'footerLinkDocs',
            link: lang === 'en' ? 'https://doc.corezoid.com/docs' : 'https://doc.corezoid.com/v2/docs',
            favorite: false
          },
          // Same documentation as the Google Doc behind doc.corezoid.com/docs,
          // for readers whose network blocks Google Docs.
          { name: 'footerLinkDocsGithub', link: 'https://github.com/corezoid/corezoid-doc', favorite: false, icons: [iconGithub] },
          {
            name: 'footerLinkMCP',
            link: 'https://corezoid.ai/',
            favorite: false
          },
          { name: 'footerLinkWorkshops', link: '/workshops', favorite: false },
          { name: 'footerLinkCertification', link: '/certification', favorite: false },
          { name: 'footerLinkFaq', link: '/faq', favorite: false },
          { name: 'footerLinkVMware', link: '/download', favorite: false },
          { name: 'footerLinkPresentations', link: 'https://docs.google.com/presentation/d/1vgG2Gx9Hcy4ssP3dljIVcaIaS2Bsenps7HJubOt_jC4/edit#slide=id.g3672661c4d_0_0', favorite: false },
          { name: 'footerLinkWhitepapers', link: 'https://docs.google.com/document/d/17fpl4-cs5g7Yqimjolq6rQdsUizO5niqUCREUCQpRhY/edit', favorite: false },
          { name: 'footerLinkGithub', link: 'https://github.com/corezoid', favorite: false, icons: [iconGithub] },
          // { type: 'lang'}
        ],
      },
      {
        title: 'footerLinkCompany',
        list: [
          { name: 'footerLinkAbout', link: '/about', favorite: false },
          { name: 'footerLinkBlog', link: '/blog', favorite: false },
          { name: 'footerLinkJobs', link: '/jobs', favorite: false },
          { name: 'footerLinkMedia', link: '/media', favorite: false },
          { name: 'footerLinkPrivacyTerms', link: '/terms-and-conditions', favorite: false },
          { name: 'footerLinkContactUs', link: '/about', favorite: true },
        ],
      },
      {
        title: 'footerLinkPartnership',
        list: [
          { name: 'footerLinkEducation', link: '/education', favorite: false },
        ],
      },
      {
        title: 'footerLinkSubscribe',
        list: [
          { type: 'text', text: 'footerTextSubscribe'},
          {
            type: 'input',
            text: 'footerInputSubscribe',
            name: 'footerInputSubscribe',
            buttonText: 'footerButtonSubscribe',
            textDane: 'footerDoneSubscribe'
          },
          {
            type: 'social',
            links: [
              {name: 'linkedIn', link: 'https://www.linkedin.com/company/middleware-official', image: 'linkedIn.png'},
              {name: 'fb', link: 'https://www.facebook.com/corezoid', image: 'facebook.png'},
              {name: 'twitter', link: 'https://twitter.com/corezoid', image: 'twitter.png'},
              {name: 'youtube', link: 'https://www.youtube.com/channel/UCoD8fgpWogDsWqk3fHkRrvA', image: 'youtube.png'},
              {name: 'rss', link: `${location}/rss.xml`, image: 'rss.png'},
              {name: 'dou', link: 'https://jobs.dou.ua/companies/corezoid/', image: 'dou.png'},
            ]
          },
        ],
      }
    ];

    return (
      <footer className="footer">
        <div className="footer">
          <div className="grid-wrapper">
            <div className="footer__nav">
              {this.renderColumn(footer, intl)}
            </div>
          </div>
          <div className="footer__copyrights">
            <div className="footer__copyrights__image middleware"><Image file={'corezoid_logo_dark_new.svg'} /></div>
            <div className="footer__copyrights__text">
              <p>
                {`${year} © Corezoid Inc., 2093 PHILADELPHIA PIKE #2235 CLAYMONT 19703 DE, US. All rights reserved.`}
              </p>
              <p>
                Patent protected.
              </p>
            </div>
            <div className="footer__copyrights__images">
              <GatsbyLink
                className="footer__copyrights__image recycle"
                to={RECYCLING_SOFTWARE_PATH}
                aria-label={intl.formatMessage({id: 'footerBadgeRecycleAriaLabel'})}
              >
                <Image file={'recycleBlack.png'} />
              </GatsbyLink>
              <a
                className="footer__copyrights__image aws"
                href={AWS_MARKETPLACE_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={intl.formatMessage({id: 'footerBadgeAwsAriaLabel'})}
              >
                <Image file={'awsFooter.png'} />
              </a>
              <GatsbyLink
                className="footer__copyrights__image iso"
                to={ISO_CERTIFICATION_PATH}
                aria-label={intl.formatMessage({id: 'footerBadgeIsoAriaLabel'})}
              >
                <Image file={'isms_c.png'} />
              </GatsbyLink>
              <GatsbyLink
                className="footer__copyrights__image claude"
                to={CLAUDE_PARTNER_CERTIFICATION_PATH}
                aria-label={intl.formatMessage({id: 'footerBadgeClaudeAriaLabel'})}
              >
                <Image
                  file={'claudePartnerFooter.png'}
                  alt={'Claude Partner Network Certified'}
                />
              </GatsbyLink>
            </div>
            {/*
              <div className="footer__copyrights__image google">
                <Image file={'google-partner.png'} />
              </div>
            */}
            {/*
              <div className="footer__copyrights__image azure">
                <Image file={'azure-certified.png'} />
              </div>
            */}
          </div>
        </div>
      </footer>
    );
  }
}

Footer.propTypes = {
  intl: PropTypes.object,
};


export default injectIntl(Footer);
